import { ReduxState, CountryFactedCounts, CountryDemographics } from '../types';
import { reverse, sortBy } from 'lodash';

const BATCH = 'BATCH';

export const batchActions = (payload: any, /* istanbul ignore next */ type = BATCH) => ({
  type,
  payload,
  meta: { batch: BATCH },
});

export const enableBatching = (reducer: any) =>
  function batchReducer(state: ReduxState, action: any) {
    switch (action && action.meta && action.meta.batch) {
      case BATCH:
        return action.payload.reduce(batchReducer, state);
      default:
        return reducer(state, action);
    }
  };

/**
 * Ideally the BE API is updated to return this data structure so we don't have to do the
 * transform on the FE.
 */
export function countryFacetedCountsToCountryDemographics(
  countryFacetedCounts: CountryFactedCounts,
): CountryDemographics[] {
  return reverse(
    sortBy(
      Object.entries(countryFacetedCounts).map(([name, { countryCode, counts }]) => {
        let sum = (a: number, b: number) => a + b;
        let count = Object.values(counts).reduce(sum, 0);
        return { name, code: countryCode, count };
      }),
      ['count'],
    ),
  );
}
